import { createRootRoute, Outlet } from '@tanstack/react-router'
import { ThemeProvider } from 'next-themes'
import { Toaster } from 'sonner'

export const Route = createRootRoute({
  component: Root,
  onError: (error) => {
    // Chunk load failures mean the browser cached old HTML pointing to stale
    // asset hashes. Force a reload to pick up the latest index.html.
    if (
      error instanceof TypeError &&
      (error.message.includes('dynamically imported module') ||
        error.message.includes('Failed to fetch'))
    ) {
      window.location.reload()
    }
  },
})

function Root() {
  return (
    <ThemeProvider attribute="class" defaultTheme="system" enableSystem>
      <Outlet />
      <Toaster richColors position="top-right" />
    </ThemeProvider>
  )
}
